<template>
  <button
    v-bind="$attrs"
    type="button"
    class="btn py-0 px-1"
    :class="[disabled ? 'text-gray-400' : 'bg-gray-hover-200']"
    :disabled="disabled"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },

  methods: {
    /**
     * @param e
     * @emits click
     */
    onClick(e) {
      this.$emit('click', e);
    },
  },
}
</script>
